import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FrameItem from './FrameItem';
import FrameVR from './FrameVR';
import '../scss/HeaderFooterBase.scss';

const allowedChildren = {
    FrameItem,
    FrameVR,
};

function renderChildren(children, variant) {
    const childrenArray = [];
    React.Children.forEach(children, (child, index) => {
        childrenArray.push(React.cloneElement(child, { variant, key: `${index + 1}` }));
    });
    return childrenArray;
}

/**
 * Sub container in Frame. Based on position prop
 * position will be decided in Frame
 */

const FrameSection = ({
    position,
    children,
    className,
    variant,
    ...otherProps
}) => (
    <div
        className={classNames('Frame__section', className)}
        {...otherProps}>
        {renderChildren(children, variant)}
    </div>
);

FrameSection.propTypes = {
    /**
     * section alignment
     */
    position: PropTypes.oneOf(['left', 'middle', 'right']).isRequired,

    children(props, propName, componentName) {
        let error;
        const prop = props[propName];
        React.Children.forEach(prop, (child) => {
            if (!(Object.values(allowedChildren)).includes(child.type)) {
                error = new Error(
                    `\`${componentName}\` only accepts childrens of type \`${Object.keys(allowedChildren)}\`.`
                );
            }
        });

        return error;
    },

    /**
     * variant for frame component
     */
    variant: PropTypes.oneOf(['Header', 'Footer']),
};

FrameSection.defaultProps = {
    children: null,
    variant: 'Header',
};

export default FrameSection;
